import * as React from 'react'
import {IMapDispatcher} from '../../core/interfaces/dispatchers'

import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {IAppStore} from '../../interfaces/reducers'
import {connect} from 'react-redux'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'
import {ReadOnlyDispatcher} from './ReadOnlyDispatcher'
import {Feature} from '../../core/models'
import {IFeatureLayerInfos, IUser} from '../../core/interfaces/reducers'

interface OwnProps {
  layerInfos: IFeatureLayerInfos
  user?: IUser
}

interface DispatchProps extends IMapDispatcher {}

interface ParentProps {
  layerId: string
  feature: Feature
}

type Props = OwnProps & DispatchProps & ParentProps

class ReadOnlyDispatcherContainer extends React.Component<Props> {
  render() {
    const layerInfo = this.props.layerInfos[this.props.layerId]
    if (layerInfo) {
      return (
        <ReadOnlyDispatcher
          layerInfo={layerInfo}
          feature={this.props.feature}
          user={this.props.user}
          mapDispatcher={this.props}
        />
      )
    } else {
      return (
        <div style={{width: '100%', height: '100%', position: 'relative'}}>
          <OverlayLoader />
        </div>
      )
    }
  }
}

const mapStateToProps = (state: IAppStore) => ({
  layerInfos: state.layerInfos.featureLayerInfos,
  user: state.userInfo.user
})

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {...appMapDispatcher})(
  ReadOnlyDispatcherContainer
)
